/**
 * Пользовательские вызовы ИИ-агентов (основное приложение и админка шаблонов).
 * Префикс `/api/v1` добавляет apiRequest.
 */

import { apiRequest } from "@/lib/api-client-v2";
import type { SpatialMcpAgentResponse } from "@/types/spatial-mcp-agent";

export interface TextGenerationResponse {
  text: string;
}

export interface TemplateArchitectChatResponse {
  message: string;
  agent_run_id: number;
  meta: {
    iterations?: number;
    elapsed_ms?: number;
    pending_approval?: { nonce: string; tool: string } | null;
    [key: string]: unknown;
  };
}

export interface ApproveToolResponse {
  ok: boolean;
  tool?: string;
  result?: Record<string, unknown>;
  error?: string | null;
}

export const aiAgentsUserApi = {
  textGeneration: (body: {
    prompt: string;
    agent_code?: string;
    max_tokens?: number;
    temperature?: number;
    model?: string;
  }) =>
    apiRequest<TextGenerationResponse>("/ai/text-generation", {
      method: "POST",
      data: body,
    }),

  analyzeGeometry: (body: {
    geometry_id: number;
    question: string;
    agent_code?: string;
    max_tokens?: number;
    temperature?: number;
    model?: string;
  }) =>
    apiRequest<{ analysis: string }>("/ai/analyze-geometry", {
      method: "POST",
      data: body,
    }),

  templateArchitectChat: (message: string) =>
    apiRequest<TemplateArchitectChatResponse>("/ai/agents/template-architect/chat", {
      method: "POST",
      data: { message },
    }),

  templateArchitectApprove: (approval_nonce: string) =>
    apiRequest<ApproveToolResponse>("/ai/agents/template-architect/approve-tool", {
      method: "POST",
      data: { approval_nonce },
    }),

  /** Агент spatial_mcp: LLM tool-loop → MCP gateway → map_camera + tool results. */
  spatialMcpChat: (message: string) =>
    apiRequest<SpatialMcpAgentResponse>("/ai/agents/spatial-mcp/chat", {
      method: "POST",
      data: { message },
    }),
};

/** Коды агентов для выпадающего списка в боковом чате (согласованы с ai.agent_definitions). */
export const SIDEBAR_CHAT_AGENT_OPTIONS = [
  { value: "default_chat", label: "Чат по умолчанию", hint: "Общие вопросы по GeoPulseML" },
  { value: "geospatial_mapper", label: "Картограф", hint: "Формулировки про геометрии и карту" },
  { value: "report_generator", label: "Создатель отчётов", hint: "Структура и текст отчётов по данным" },
  {
    value: "spatial_mcp",
    label: "Пространственный MCP",
    hint: "Ближайшие объекты, буфер, поиск — результат на карте",
  },
] as const;

export const SPATIAL_MCP_AGENT_CODE = "spatial_mcp" as const;
